import { render, staticRenderFns } from "./ConnectionError.vue?vue&type=template&id=4b8a9611&"
import script from "./ConnectionError.vue?vue&type=script&lang=ts&"
export * from "./ConnectionError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports